import React, { useEffect } from 'react';
import './assets/scss/App.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { RegistrationFormComponent } from './shared/RegistrationFormComponent';
import { tracker } from './openreplay';

type AppProps = {
  eventId?: number;
};

const App: React.FC<AppProps> = ({ eventId }) => {
  useEffect(() => {
    tracker.start();
  }, []);

  const router = createBrowserRouter([
    {
      path: '*',
      element: <RegistrationFormComponent eventId={eventId} />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
